import React from "react";
import { CircleCheck, Clock, TriangleAlert } from "lucide-react";

interface StatusBadgeProps {
  status: string;
  className?: string;
  message?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = "", message }) => {
  let color = "";
  let icon = null;
  if (status === "completed" || status === "success") {
    color = "bg-green-100 text-green-800";
    icon = <CircleCheck className="w-4 h-4 mr-1 text-green-500" />;
  } else if (status === "processing") {
    color = "bg-blue-100 text-blue-800";
    icon = <Clock className="w-4 h-4 mr-1 text-blue-500" />;
  } else if (status === "failed" || status === "error") {
    color = "bg-red-100 text-red-800";
    icon = <TriangleAlert className="w-4 h-4 mr-1 text-red-500" />;
  }
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${color} ${className}`}>
      {icon}
      {status === "error" && message ? (
        <span>Error: {message}</span>
      ) : (
        <span className="capitalize">{status}</span>
      )}
    </span>
  );
};

export default StatusBadge; 